import { render, staticRenderFns } from "./rmKltg.vue?vue&type=template&id=7ffdb250"
import script from "./rmKltg.vue?vue&type=script&lang=js"
export * from "./rmKltg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports